export const IsWebReference = (endOfReferenceValue: string) => {
    let webReference = localStorage.getItem('webReference') || "";
    return webReference.endsWith(endOfReferenceValue);
}

export const IsWebReferenceNotLocalStorage = (webReferenceValue: string, endOfReferenceValue: string) => {
    return webReferenceValue.endsWith(endOfReferenceValue);
}

export const IsWebReferenceSuffix = (webReferenceValue: string, checkValue: string) => {
    let webReferenceSuffix = GetWebReferenceSuffix(webReferenceValue)
    return webReferenceSuffix == checkValue;
}

export const GetWebReferenceSuffix = (webReferenceValue: string) => {
    let siteConfig = JSON.parse(localStorage.getItem("siteConfig") || JSON.stringify({}));
    let webReferencePrefix = siteConfig.activeSite;
    return webReferenceValue.substring(webReferencePrefix.length);
}

export const IsProductDetailsEnabled = () => {
    let siteConfig = JSON.parse(localStorage.getItem('siteConfig') || "{}");
    let webReference = localStorage.getItem('webReference') || "";
    let productDetailsEnabledProducts = siteConfig.productDetailsEnabledProducts.split(",");
    let webReferenceSuffix = GetWebReferenceSuffix(webReference);
    return productDetailsEnabledProducts.includes(webReferenceSuffix);
}